import { render, staticRenderFns } from "./InventoryOverview.vue?vue&type=template&id=2d27f28a&scoped=true&"
import script from "./InventoryOverview.vue?vue&type=script&lang=js&"
export * from "./InventoryOverview.vue?vue&type=script&lang=js&"
import style0 from "./InventoryOverview.vue?vue&type=style&index=0&id=2d27f28a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d27f28a",
  null
  
)

export default component.exports